import {LastMatchesLayoutDataColumnDomainModel} from "./game-h2h.competitor.layout-data.column.domain-model";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {GameH2hCompetitorLayoutDataDomainModel} from "./game-h2h.competitor.layout-data.domain-model";
import {LastMatchesLayoutDataColumnViewModel} from "./game-h2h.competitor.layout-data.column.view-model";

export class GameH2hCompetitorLayoutDataViewModel extends BaseViewModel {
  domainModel: GameH2hCompetitorLayoutDataDomainModel;

  get columns(): Array<LastMatchesLayoutDataColumnViewModel> {
    return this.domainModel.columns?.map((column: LastMatchesLayoutDataColumnDomainModel) => new LastMatchesLayoutDataColumnViewModel(column))
  }
}